import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import _Select from "../../../generic/_Select";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";

const WhatsappControl = () => {
  const Auth = useAuth();
  const { token } = Auth.getSessionData();
  const { values, setFieldValue, errors, touched, handleBlur } =
    useFormikContext();

  const { data: templates, isPending } = useQuery({
    queryKey: ["whatsappTemplates"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}whatsapp/templates`,
        {},
        token
      );

      return response.data;
    },
    initialData: [],
    enabled: values.isWhatsApp,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    let templateData = templates.filter((x) => x.id == values.selectedTemplate);
    let message = templateData.length > 0 ? templateData[0].data : "";
    setFieldValue("whmessage", message);
  }, [values.selectedTemplate]);
  return (
    <div className="px-4 py-2">
      <_Select
        name="selectedTemplate"
        title="Plantilla Whatsapp"
        label="Plantilla Whatsapp"
        options={[
          { label: "Seleccione una plantilla", value: "" },
          ...templates.map((template) => ({
            label: template.elementName,
            value: template.id,
          })),
        ]}
        onChange={(e) => {
          setFieldValue("selectedTemplate", e.target.value);
        }}
        values={values.selectedTemplate}
        onBlur={handleBlur}
        error={touched.selectedTemplate && errors.selectedTemplate}
        isLoading={isPending}
      />
    </div>
  );
};

export default WhatsappControl;
